import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faShield,
  faLock,
  faClock,
  faCalendarCheck,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import "../../styles/logistic/LogisticCtaSection.css";
import serviceBot from "../../assets/app/Logistic/customer-service-bot.png";
import { useTranslation } from "react-i18next";

const LogisticCtaSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-cta-section" id="cta">
      <div className="logistic-container">
        <div className="logistic-cta-content">
          <div className="logistic-cta-hero-image">
            <img
              src={serviceBot}
              alt={t("LogisticCtaSection:alt_text")}
              loading="lazy"
            />
          </div>

          <div className="logistic-cta-header">
            <h2>
              {t("LogisticCtaSection:title_prefix")}{" "}
              <span className="logistic-text-gradient">{t("LogisticCtaSection:title_strong")}</span>
            </h2>
            <p>{t("LogisticCtaSection:subtitle")}</p>
          </div>

          <div className="logistic-cta-form-container">
            <div className="logistic-cta-benefits">
              <h3>{t("LogisticCtaSection:demo_benefits_title")}</h3>
              <ul>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} /> {t("LogisticCtaSection:demo_benefit1")}
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} /> {t("LogisticCtaSection:demo_benefit2")}
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} /> {t("LogisticCtaSection:demo_benefit3")}
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} /> {t("LogisticCtaSection:demo_benefit4")}
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} /> {t("LogisticCtaSection:demo_benefit5")}
                </li>
              </ul>

              <div className="logistic-cta-trust">
                <div className="logistic-trust-item">
                  <FontAwesomeIcon icon={faShield} />
                  <span>{t("LogisticCtaSection:trust_item1")}</span>
                </div>
                <div className="logistic-trust-item">
                  <FontAwesomeIcon icon={faLock} />
                  <span>{t("LogisticCtaSection:trust_item2")}</span>
                </div>
                <div className="logistic-trust-item">
                  <FontAwesomeIcon icon={faClock} />
                  <span>{t("LogisticCtaSection:trust_item3")}</span>
                </div>
              </div>
            </div>

            <div className="logistic-cta-form">
              <form id="contactForm">
                <div className="logistic-form-group">
                  <label htmlFor="name">{t("LogisticCtaSection:form_name_label")}</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    placeholder={t("LogisticCtaSection:form_name_placeholder")}
                  />
                </div>

                <div className="logistic-form-group">
                  <label htmlFor="email">{t("LogisticCtaSection:form_email_label")}</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    placeholder={t("LogisticCtaSection:form_email_placeholder")}
                  />
                </div>

                <div className="logistic-form-group">
                  <label htmlFor="phone">{t("LogisticCtaSection:form_phone_label")}</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    placeholder={t("LogisticCtaSection:form_phone_placeholder")}
                  />
                </div>

                <div className="logistic-form-group">
                  <label htmlFor="company">{t("LogisticCtaSection:form_company_label")}</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    required
                    placeholder={t("LogisticCtaSection:form_company_placeholder")}
                  />
                </div>

                <div className="logistic-form-group">
                  <label htmlFor="volume">
                    {t("LogisticCtaSection:form_volume_label")}
                  </label>
                  <select id="volume" name="volume" required>
                    <option value="">{t("LogisticCtaSection:form_volume_option1")}</option>
                    <option value="0-5000">{t("LogisticCtaSection:form_volume_option2")}</option>
                    <option value="5000-15000">{t("LogisticCtaSection:form_volume_option3")}</option>
                    <option value="15000-50000">
                      {t("LogisticCtaSection:form_volume_option4")}
                    </option>
                    <option value="50000+">{t("LogisticCtaSection:form_volume_option5")}</option>
                  </select>
                </div>

                <div className="logistic-form-group">
                  <label htmlFor="message">
                    {t("LogisticCtaSection:form_message_label")}
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={3}
                    placeholder={t("LogisticCtaSection:form_message_placeholder")}
                  ></textarea>
                </div>

                <button type="submit" className="logistic-btn-submit">
                  <FontAwesomeIcon icon={faCalendarCheck} />
                  {t("LogisticCtaSection:form_submit_button")}
                </button>

                <p className="logistic-form-note">
                  <FontAwesomeIcon icon={faInfoCircle} />
                  {t("LogisticCtaSection:form_note")}
                </p>
              </form>

              <div
                id="formSuccess"
                className="logistic-form-success"
                style={{ display: "none" }}
              >
                <FontAwesomeIcon icon={faCheckCircle} />
                <h3>{t("LogisticCtaSection:success_title")}</h3>
                <p>
                  {t("LogisticCtaSection:success_text1")}
                </p>
                <p className="logistic-success-note">
                  {t("LogisticCtaSection:success_text2")}
                </p>
              </div>
            </div>
          </div>

          <div className="logistic-cta-footer">
            <p>
              <strong>{t("LogisticCtaSection:footer_bonus_prefix")}</strong>{" "}
              {t("LogisticCtaSection:footer_bonus_strong")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticCtaSection;
